import { Injectable } from "@angular/core";
import { UPDATED_TC_DIALOG_ID } from "@obg/mat.ui.common";
import { DialogLike, DialogService } from "@obg/mat.ui.core";
import { map } from "rxjs/operators";

import { UpdatedTermsAndConditionsContainer } from "./updated-terms-and-conditions.container";

export { UPDATED_TC_DIALOG_ID };

export const UPDATED_TC_DIALOG: DialogLike<UpdatedTermsAndConditionsContainer> = {
	dialogId: UPDATED_TC_DIALOG_ID,
	dialogComponentType: UpdatedTermsAndConditionsContainer,
	onClose$: (c) => c.close,
	onBusy$: (c) => c.busy.pipe(map((isBusy) => ({ isBusy }))),
};

@Injectable({
	providedIn: "root",
})
export class UpdatedTermsAndConditionsDialogService {
	constructor(private dialogService: DialogService) {}

	open() {
		return () => {
			this.dialogService.openComponent(UPDATED_TC_DIALOG, {
				disableClose: true,
				panelClass: "terms-and-conditions-dialog",
				data: {
					hideClose: true,
					hideFooter: true,
				},
				autoFocus: false,
			});
		};
	}
}
